export default "__VITE_ASSET__Dpu8mRTV__"